import { createAction, ActionsUnion } from "../definitions";
import { TimeZoneInfoActionTypes } from "./types";
import { ITimeZoneInfo } from "../../utils/date";

export interface ITimeZoneInfoPayload {
    userId: string;
    timeZoneInfo?: ITimeZoneInfo;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TimeZoneInfoActions = {
    clearTimeZoneInfo: (payload?: ITimeZoneInfoPayload) => createAction(TimeZoneInfoActionTypes.CLEAR_TIME_ZONE_INFO, payload),
    setTimeZoneInfo: (payload: ITimeZoneInfoPayload) => createAction(TimeZoneInfoActionTypes.SET_TIME_ZONE_INFO, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TimeZoneInfoActions = ActionsUnion<typeof TimeZoneInfoActions>;